export default __webpack_public_path__ + "static/media/DENTISTCERTIFICATE_BLANK.48a962d6.png";